import React from "react";
import { TopBar } from "@/components/TopBar";
import { CATATAN, jenisKenaikan, urutTerbaru } from "@/lib/catatanPembaruan";
import { teksVersi } from "@/lib/branding";
import { tanggalIndo } from "@/lib/format";
import { Sparkles, Wrench, Rocket, History } from "lucide-react";

// owner 2026-10-17 (VERSI-APLIKASI): release notes per version in plain words, for every
// role. The list is data shipped with the build (lib/catatanPembaruan.js); the version the
// user is running comes from the build (file VERSI) — a newer server version shows a banner
// elsewhere (VersiBaru), this page simply lists what each number brought.
const LABEL = { besar: ["Perubahan besar", Rocket, "border-soq-oranye/60 text-soq-oranye"],
  fitur: ["Fitur baru", Sparkles, "border-soq-biru/50 text-soq-biru"],
  perbaikan: ["Perbaikan", Wrench, "border-emerald-500/50 text-emerald-700"] };

export default function CatatanPembaruan() {
  const daftar = urutTerbaru(CATATAN);
  const sekarang = process.env.REACT_APP_VERSI_NOMOR;
  return (
    <div data-testid="catatan-pembaruan-page" className="min-h-screen bg-slate-950 text-slate-200">
      <TopBar />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-6">
        <div>
          <h1 className="flex items-center gap-2 text-2xl font-bold tracking-tight text-slate-100 sm:text-3xl"><History size={26} className="text-soq-oranye" /> Catatan pembaruan</h1>
          <p className="mt-1 text-sm text-slate-400">Apa yang berubah di aplikasi pada setiap versi, dalam bahasa sederhana.
            {teksVersi(sekarang) && <> Versi yang sedang Anda pakai: <b data-testid="catatan-versi-sekarang" className="text-slate-200">{teksVersi(sekarang)}</b>.</>}</p>
          <p className="mt-2 text-xs text-slate-500">Aturan nomor: fitur baru menaikkan angka kedua (2.9 → 2.10), perbaikan saja menaikkan angka ketiga (2.9 → 2.9.1), perubahan besar menaikkan angka pertama (3.0). Versi 1.0 (rilis awal, 7 Oktober) sampai 1.2 diringkas pada entri v2.0.</p>
        </div>
        <ol className="space-y-4" data-testid="catatan-daftar">
          {daftar.map((c, i) => {
            const sebelumnya = daftar[i + 1];
            // the oldest listed entry (2.0) has no predecessor on the page: an X.0 number is a big change
            const jenis = sebelumnya ? jenisKenaikan(sebelumnya.versi, c.versi) : (/\.0$/.test(c.versi) ? "besar" : null);
            const [label, Ikon, warna] = LABEL[jenis] || ["Versi awal", History, "border-slate-600 text-slate-400"];
            const aktif = c.versi === sekarang;
            return (
              <li key={c.versi} data-testid={`catatan-${c.versi}`} className={`rounded-xl border p-4 ${aktif ? "border-amber-500/60 bg-amber-500/5" : "border-slate-800 bg-slate-900/60"}`}>
                <div className="flex flex-wrap items-center gap-2">
                  <span className="text-lg font-bold text-slate-100">v{c.versi}</span>
                  <span className={`inline-flex items-center gap-1 rounded border px-1.5 py-0.5 text-[11px] font-semibold ${warna}`}><Ikon size={12} /> {label}</span>
                  {aktif && <span className="rounded border border-amber-500/60 px-1.5 py-0.5 text-[11px] font-semibold text-amber-300">versi Anda</span>}
                  <span className="ml-auto text-xs text-slate-500">{tanggalIndo(c.tanggal)} · {c.untuk}</span>
                </div>
                <div className="mt-1 font-semibold text-slate-200">{c.judul}</div>
                <ul className="mt-2 list-disc space-y-1 pl-5 text-sm text-slate-300">{c.butir.map((b) => <li key={b}>{b}</li>)}</ul>
              </li>
            );
          })}
        </ol>
      </main>
    </div>
  );
}
